const Dollar = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#7A877D"
        d="M9.41 15.673h1.139v-1.01a3.673 3.673 0 0 0 1.755-.728c.524-.398.786-1.001.786-1.81 0-.583-.172-1.1-.516-1.548-.344-.449-1.016-.854-2.016-1.215-.876-.299-1.457-.558-1.745-.777-.287-.219-.43-.525-.43-.918s.146-.713.44-.959c.295-.245.701-.368 1.22-.368.433 0 .783.102 1.049.307.266.204.47.461.614.77l1.029-.414a2.719 2.719 0 0 0-.852-1.138 2.32 2.32 0 0 0-1.293-.529v-1.01H9.453v1.01c-.71.137-1.257.425-1.637.865-.381.44-.572.928-.572 1.466 0 .626.19 1.13.57 1.511.378.381.997.726 1.853 1.033.886.325 1.491.617 1.815.875.325.258.487.604.487 1.039 0 .523-.189.902-.566 1.139a2.353 2.353 0 0 1-1.277.355c-.47 0-.889-.141-1.26-.423-.37-.282-.654-.695-.853-1.238l-1.054.43c.216.618.526 1.11.93 1.474.405.364.912.618 1.522.76v1.051Zm.59 2.244a7.694 7.694 0 0 1-3.085-.625A8.004 8.004 0 0 1 4.401 15.6a8.005 8.005 0 0 1-1.693-2.513A7.696 7.696 0 0 1 2.084 10c0-1.094.208-2.123.624-3.086a8.005 8.005 0 0 1 1.693-2.513 8.005 8.005 0 0 1 2.514-1.693 7.696 7.696 0 0 1 3.086-.625c1.094 0 2.122.208 3.085.625.963.416 1.801.98 2.514 1.693a8.004 8.004 0 0 1 1.693 2.513c.416.963.624 1.992.624 3.086a7.694 7.694 0 0 1-.624 3.086 8.004 8.004 0 0 1-1.693 2.513 8.004 8.004 0 0 1-2.514 1.694 7.694 7.694 0 0 1-3.085.624Z"
      />
    </g>
  </svg>
)
export default Dollar
